const WAF_TOKEN_TIMEOUT_MS = 1000

// True only for junglescout.com API hosts (apex or subdomain); excludes the .CN edge and localhost.
export const isAwsWafTokenDomain = apiRoot => {
  try {
    const { hostname } = new URL(apiRoot)

    return (
      hostname === 'junglescout.com' || hostname.endsWith('.junglescout.com')
    )
  } catch (e) {
    return false
  }
}

// Returns the AWS WAF token from the challenge.js SDK; no-ops when the SDK is absent or slow.
export const getAwsWafToken = async () => {
  try {
    const integration = window.AwsWafIntegration

    if (!integration || typeof integration.getToken !== 'function') {
      return null
    }

    const timeout = new Promise(resolve => {
      setTimeout(() => resolve(null), WAF_TOKEN_TIMEOUT_MS)
    })

    return await Promise.race([integration.getToken(), timeout])
  } catch (e) {
    return null
  }
}
